
export const skill = [
    {
        type: "frontEnd",
        title: "Front-end",
        language: [
            {
                name: "ReactJS",
                imgURL: "./icon/reactjs.png",
                level: 90,
            },
            {
                name: "Javascript",
                imgURL: "./icon/javascript.png",
                level: 90,
            },
            {
                name: "HTML",
                imgURL: "./icon/html.png",
                level: 90,
            },
            {
                name: "CSS",
                imgURL: "./icon/css.png",
                level: 88,
            },
            {
                name: "Type Script",
                imgURL: "./icon/ts.svg",
                level: 80,
            },
            {
                name: "NextJS",
                imgURL: "./icon/nextjs.png",
                level: 60,
            }
        ],
    },
    {
        type: "backEnd",
        title: "Back-end",
        language: [
            {
                name: "Python",
                imgURL: "./icon/python.png",
                level: 90,
            },
            {
                name: "Django",
                imgURL: "./icon/django.png",
                level: 88,
            },
            {
                name: "NodeJS",
                imgURL: "./icon/nodejs.png",
                level: 90,
            },
            {
                name: "MySQL",
                imgURL: "./icon/mysql.png",
                level: 90,
            },
            {
                name: "Sequelize",
                imgURL: "./icon/sequelize.png",
                level: 85,
            },
            {
                name: "Jest",
                imgURL: "./icon/jest.png",
                level: 80,
            },
            {
                name: "mongoDB",
                imgURL: "./icon/mongodb.png",
                level: 75,
            },
            {
                name: "OCI",
                imgURL: "./icon/OCI.png",
                level: 60,
            },
        ],
    },
    {
        type: "Design",
        title: "UI/UX Design",
        language: [
            {
                name: "Figma",
                imgURL: "./icon/figma.png",
                level: 90,
            },
            {
                name: "Adobe XD",
                imgURL: "./icon/xd.png",
                level: 80,
            }
        ],
    },
    {
        type: "Deployment",
        title: "Deployment",
        language: [
            {
                name: "Git Hub",
                imgURL: "./icon/git.png",
                level: 70,
            },
            {
                name: "AWS",
                imgURL: "./icon/aws.png",
                level: 75,
            },
            {
                name: "Linux Server",
                imgURL: "./icon/linux.png",
                level: 65,
            },
        ],
    },
];
